import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchService } from '../../services/search';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-detail',
    templateUrl: 'detail.html',
    styleUrls: ['detail.css']
})

export class DetailComponent implements OnInit {

    personId: string;
    person: any;
    forms: any[];

    formsLoading = true;
    personLoading = true;

    constructor(private search: SearchService,
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.personId = params['id'];
            this.search.details(this.personId);
            this.search.forms(+this.personId);
        });

        this.search.item$.subscribe((data: any) => {
            this.person = data;
            this.personLoading = false;
        });

        this.search.forms$.subscribe((data: any[]) => {
            this.forms = data;
            this.formsLoading = false;
        });
      }

    open(url: string) {
        this.http.get(url, { responseType: 'blob'})
            .map(res => {
            return new Blob([res], { type: 'application/txt', });
        })
        .subscribe((data) => {
            const tab = window.open();
            const fileUrl = URL.createObjectURL(data);
            tab.location.href = fileUrl;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/detail/detail.ts